import {ImageOff} from 'lucide-react';

/**
 Stands in for the media of an item whose image is withheld: either it was classified under a
 sensitive risk and its stored imagery purged, or its image matches one an earlier purge removed.
 The API returns no thumbnail for it, so there is nothing to blur.
 */
export function ImagesPurgedPlaceholder({
  reason
}: {
  readonly reason?: 'sensitive_risk' | 'matches_purged_image' | null | undefined;
}) {
  return (
    <div className="text-muted-foreground flex h-full flex-col items-center justify-center gap-1 px-2 text-center text-xs">
      <ImageOff className="size-8" aria-hidden="true" />
      {reason === 'matches_purged_image'
        ? 'Image hidden: matches a previously removed image'
        : 'Image removed (sensitive risk)'}
    </div>
  );
}
